import {Button, Grid, IconButton, Typography} from "@mui/material";
import {useEffect, useState} from "react";
import {Add, HorizontalRule} from '@mui/icons-material'

export const useCantidadBotones = ({producto}) => {
    const alto = 50


    const Botones = ({varianteEscogida, clickAgregar, clickComprarAhora, cargando}) => {
        const [cantidad, setCantidad] = useState(1)
        const [maximo, setMaximo] = useState(1)


        const agregar = () => {
            if (cantidad < maximo) {
                let can = cantidad + 1
                setCantidad(can)
            }
        }

        const restar = () => {
            if (cantidad > 0) {
                let can = cantidad - 1
                setCantidad(can)
            }
        }

        const cambiarCantidadDefecto = (nomVar) => {

            if (producto && producto.variaciones) {
                let variaciones = producto.variaciones

                let index = variaciones.findIndex((e) => e.nombre == nomVar)
                if (index > -1) {
                    let varia = variaciones[index]
                    if (varia.cantidad && parseInt(varia.cantidad) > 0) {
                        setCantidad(1)
                        setMaximo(parseInt(varia.cantidad))
                    } else {
                        setCantidad(0)
                        setMaximo(0)
                    }

                }


            }
        }


        useEffect(() => {
            cambiarCantidadDefecto(varianteEscogida)
        }, [varianteEscogida])
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={2}
                >

                    <Grid
                        container
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        size={{xs: 6, sm: 6, md: 4}}
                        sx={{border: 1, p: 1, height: alto}}
                    >


                        <IconButton onClick={() => restar()}>
                            <HorizontalRule sx={{width: 20, height: 20}}/>
                        </IconButton>

                        <Typography>
                            {cantidad}
                        </Typography>

                        <IconButton onClick={() => agregar()}>
                            <Add sx={{width: 20, height: 20}}/>
                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 6, sm: 6, md: 8}} sx={{justifyContent: 'flex-start'}}>
                        <Button
                            disabled={cantidad === 0}
                            loading={cargando}
                            onClick={() => clickAgregar(cantidad)}
                            variant={'outlined'} fullWidth sx={{height: alto}}>AGREGAR AL CARRITO</Button>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Button
                            disabled={cantidad === 0}
                            loading={cargando}
                            onClick={() => clickComprarAhora(cantidad)}
                            fullWidth sx={{height: alto}}>COMPRAR AHORA</Button>
                    </Grid>


                </Grid>

            </Grid>
        )
    }

    return {
        Botones,
    }
}